<ion-header>
  <ion-toolbar>
    <ion-title>{{ 'm/task-process/attach/gifs' | translate }}</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()">{{ 'm/close' | translate }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-searchbar
    (ionChange)="onSearchInputChange($event)"
    debounce="500"
    placeholder="{{ 'm/task-process/gifs/search' | translate }}"></ion-searchbar>
</ion-header>

<ion-content>
  <ion-item lines="none" *ngIf="availableGifs.length > 0">
    <img class="giphy-logo" src="assets/img/giphy-logo.png" />
  </ion-item>
  <ion-grid class="gifs-grid">
    <ion-row>
      <ion-col *ngFor="let gif of filteredGifs" size="6">
        <ion-thumbnail (click)="onGifClick(gif)">
          <img [src]="gif.images.preview_gif.url" />
        </ion-thumbnail>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-infinite-scroll threshold="100px" (ionInfinite)="loadMoreGifs($event)">
    <ion-infinite-scroll-content></ion-infinite-scroll-content>
  </ion-infinite-scroll>

  <div *ngIf="availableGifs.length === 0" class="no-gifs-msg">
    {{ 'm/task-process/gifs/no-gifs-available' | translate }}
  </div>
</ion-content>
